<style lang="less" scoped>
    .stock-picker{
        display: inline-block;
        width: 100%;
        vertical-align: middle;
        .ivu-poptip{
            width: 100%;
            /deep/ .ivu-poptip-rel{
                width: 100%;
            }
        }
        .default-slot{
            /deep/ .ivu-btn {
                padding: 6px 7px;
                text-align: left;
            }
            /deep/ .ivu-btn-small {
                padding: 2px 7px;
            }
        }
    }
    .stock{
        margin-bottom: 5px;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        border: 1px solid #dddee1;
        padding: 5px 8px;
        cursor: pointer;
        &:hover{
            background: #f5f5f5;
        }
    }
    .sub-stocks{
        padding-left: 8px;
        white-space: normal;
    }
</style>
<template>
    <div class="stock-picker">
        <Poptip :transfer="true" width="450" :placement="placement" @on-popper-show="popShow">
            <div class="default-slot">
                <slot>请选择</slot>
            </div>
            <div slot="content">
                <i-input size="small" v-model="params.search" @on-enter="search" placeholder="搜索存货...">
                    <Button slot="append" icon="ios-search" @click="search" :loading="loading"></Button>
                </i-input>
                <div class="hr"></div>
                <div class="stock" v-for="stock in stocks" @click="selectStock(stock)" :key="stock.id">
                    <span>{{stockText(stock)}}</span>  <span style="color:#33CCCC">{{stock.name}}</span>
                    <!--<div>{{stockText(stock)}}</div>-->
                </div>
            </div>
        </Poptip>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                type: String,
            },
            placement: {
                type: String,
                default: 'bottom-start'
            }
        },
        data(){
            return {
                params: {
                    search: '',
                    page: 1,
                    per_page: 5
                },
                stocks: [],
                loading: false
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            popShow() {
                if (!this.stocks.length) {
                    this.search();
                }
            },
            search(){
                this.loading = true;
                Util.ajax.get(Util.api.es_query_online_stock, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.loading = false;
                    this.stocks = [];
                    if(res.code === 1){
                        let data = res.data;
                        this.stocks = data.stocks;
                        if(this.stocks.length === 0){
                            this.$Message.warning('未搜索到相关存货');
                        }
                    }else{
                        this.$Modal.error({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    this.loading = false;
                    this.$Modal.error({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            stockText(stock) {
                //return  "<span>${stock.uid || '未分配编号'}-${stock.tax_code ? stock.tax_code.code : '未选择税码'}</span>"+"<span>${stock.name}</span>";
                //return `${stock.uid || '未分配编号'}-${stock.tax_code ? stock.tax_code.code : '未选择税码'} ${stock.name}`;
                return `${stock.uid || '未分配编号'}-${stock.tax_code ? stock.tax_code.code : '未选择税码'}`;
            },
            selectStock(stock){
                if(!stock.uid){
                    this.$Modal.warning({title: '提示', content: '未分配存货编码，无法选择'});
                    return;
                }
                if(!stock.tax_code){
                    this.$Modal.warning({title: '提示', content: '未设置税率，无法选择'});
                    return;
                }
                if(!stock.group){
                    this.$Modal.warning({title: '提示', content: '未设置产品分类，无法选择'});
                    return;
                }
                this.$emit('on-change', `${stock.uid}-${stock.tax_code.code}`, stock.group, stock.barcode);
                document.body.click();
            }
        }
    }
</script>
